import prescriptionService from '../services/apiRequests/prescription.service';

export default {
    namespaced: true,
    state: {
        ObjectHouseList: [],
        ObjectHouseListLength: 0,
        ObjectHousePagination: null,
        ObjectHouseLoading: false,
        PrescriptionList: [],
        PrescriptionListLength: 0,
        PrescriptionPagination: null,
        PrescriptionLoading: false,
        EventTypeList: [],
        PrescriptionInfo: {},
        paramSaved: null,
        prescriptionStatusTypes: [],
        EngineerKSKHousesList: [],
        EngineerContractsList: [],
        EngineerObjectContractsList: [],
        iengineer_rid: null
    },
    mutations: {
        setiengineer_rid(state, iengineer_rid) {
            state.iengineer_rid = iengineer_rid;
        },
        setEngineerObjectContractsList(state, EngineerObjectContractsList) {
            state.EngineerObjectContractsList = EngineerObjectContractsList;
        },
        setEngineerContractsList(state, EngineerContractsList) {
            state.EngineerContractsList = EngineerContractsList;
        },
        setEngineerKSKHousesList(state, EngineerKSKHousesList) {
            state.EngineerKSKHousesList = EngineerKSKHousesList;
        },
        setprescriptionStatusTypes(state, prescriptionStatusTypes) {
            state.prescriptionStatusTypes = prescriptionStatusTypes;
        },
        setparamSaved(state, paramSaved) {
            state.paramSaved = paramSaved;
        },
        setPrescriptionInfo(state, PrescriptionInfo) {
            state.PrescriptionInfo = PrescriptionInfo;
        },
        setEventTypeList(state, EventTypeList) {
            state.EventTypeList = EventTypeList;
        },
        setObjectHouseList(state, ObjectHouseList) {
            state.ObjectHouseList = ObjectHouseList;
        },
        setObjectHouseListLength(state, ObjectHouseListLength) {
            state.ObjectHouseListLength = ObjectHouseListLength;
        },
        setObjectHousePagination(state, ObjectHousePagination) {
            state.ObjectHousePagination = ObjectHousePagination;
        },
        setObjectHouseLoading(state, ObjectHouseLoading) {
            state.ObjectHouseLoading = ObjectHouseLoading;
        },
        setPrescriptionList(state, PrescriptionList) {
            state.PrescriptionList = PrescriptionList;
        },
        setPrescriptionListLength(state, PrescriptionListLength) {
            state.PrescriptionListLength = PrescriptionListLength;
        },
        setPrescriptionPagination(state, PrescriptionPagination) {
            state.PrescriptionPagination = PrescriptionPagination;
        },
        setPrescriptionLoading(state, PrescriptionLoading) {
            state.PrescriptionLoading = PrescriptionLoading;
        }
    },
    actions: {
        async getObjectsHouses({ commit, state }, { engineer_rid, itemsPerPage, currentItem }) {
            try {
                commit('setObjectHouseList', []);
                commit('setObjectHouseListLength', 0);
                commit('setObjectHouseLoading', true);
                const param = { engineer_rid: engineer_rid };
                const res = await prescriptionService.getObjectsHouses(itemsPerPage, currentItem, param);
                commit('setObjectHouseList', res.objects_houses);
                if (res && res.pagination && res.pagination.row_count) commit('setObjectHouseListLength', res.pagination.row_count);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setObjectHouseLoading', false);
            }
        },
        async getPrescriptions({ commit, state }, { engineer_rid, contract_rid, ksk_rid, user_id, itemsPerPage, currentItem }) {
            try {
                commit('setPrescriptionList', []);
                commit('setPrescriptionListLength', 0);
                commit('setPrescriptionLoading', true);
                let param = { engineer_rid: engineer_rid, contract_rid: contract_rid, ksk_rid: ksk_rid, user_id: user_id };
                if (!engineer_rid && !contract_rid && !ksk_rid && !user_id) {
                    param = state.paramSaved;
                } else {
                    commit('setparamSaved', param);
                }
                const res = await prescriptionService.getPrescriptions(itemsPerPage, currentItem, param);
                commit('setPrescriptionList', res.ahs_requests);
                if (res && res.pagination && res.pagination.row_count) commit('setPrescriptionListLength', res.pagination.row_count);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setPrescriptionLoading', false);
            }
        },
        async getEventTypes({ commit }) {
            try {
                commit('setEventTypeList', []);
                const res = await prescriptionService.getEventTypes();
                commit('setEventTypeList', res);
            } catch (e) {
                console.error(e);
            }
        },
        async getPrescriptionInfo({ commit }, { iPrescription_rid }) {
            try {
                commit('setPrescriptionInfo', {});
                const res = await prescriptionService.getPrescriptionInfo(iPrescription_rid);
                commit('setPrescriptionInfo', res);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async postPrescriptions({ commit }, { nvcPrescriptionData }) {
            return await prescriptionService.postPrescriptions(nvcPrescriptionData);
        },
        async prescriptionStatusChange({ commit }, { iPrescription_rid, iStatus_rid }) {
            return await prescriptionService.prescriptionStatusChange(iPrescription_rid, iStatus_rid);
        },
        async GetPrescriptionStatusTypes({ commit }) {
            try {
                commit('setprescriptionStatusTypes', []);
                const res = await prescriptionService.prescriptionStatusTypes();
                commit('setprescriptionStatusTypes', res);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getEngineerKSKHousesList({ commit }, { iengineer_rid }) {
            try {
                commit('setEngineerKSKHousesList', []);
                const res = await prescriptionService.getEngineerKSKHousesList(iengineer_rid);
                commit('setEngineerKSKHousesList', res.houses);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getEngineerContractsList({ commit }, { iengineer_rid }) {
            try {
                commit('setEngineerContractsList', []);
                const res = await prescriptionService.getEngineerContractsList(iengineer_rid);
                commit('setEngineerContractsList', res.contracts);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getEngineerObjectContractsList({ commit }, { icontract_rid, iengineer_rid }) {
            try {
                commit('setEngineerObjectContractsList', []);
                const res = await prescriptionService.engineerObjectContractsList(icontract_rid, iengineer_rid);
                commit('setEngineerObjectContractsList', res.object_contracts);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        }
    }
};
